<template>

  <div
    v-if="filled"
    class="card-body">
    <div class="d-flex">
      <div
        class="mr-3">
        <StarsScore
          v-if="placement.match_score"
          :value="placement.match_score" />
      </div>
      <div>
        <div v-if="!show">
          <span class="text-muted">{{ shurtText }}</span>
          <a href="javascript:void(0)" @click="show=true">{{ $t('Show more') }}</a>
        </div>
        <div v-if="show">
          {{ placement.match_description }}
          <a href="javascript:void(0)" @click="show=false">{{ $t('Show less') }}</a>
        </div>
      </div>
    </div>
  </div>

</template>

<script>
import StarsScore from '@/components/Parts/StarsScore'
export default {
  name: 'CandidateProfileMatchDescription',
  components: {
    StarsScore
  },
  data () {
    return {
      show: false
    }
  },
  created () {
  },
  computed: {
    candidateJobId () {
      return this.$route.query.candidate_job_id
    },
    candidate () {
      return this.$store.getters.getCandidate
    },
    placement () {
      if (!this.candidateJobId) return null
      return this.candidate.placements.find((placement) => {
        return placement.job_id === this.candidateJobId
      })
    },
    filled () {
      return this.placement && this.placement.match_description
    },
    shurtText () {
      return this.placement.match_description.slice(0, 100)
    },
    label () {
      const score = 5 * this.placement.match_score
      const scoreStr = score.toFixed(2)
      return `${scoreStr}/5`
    }
  },
  methods: {
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Candidate/Profile/CandidateProfileMatchDescription.vue